import Base from "./base.service.js";
export default class ExtraTask extends Base {
    constructor() {
        super("extra-task");
    }
}
